import { useContext } from 'react';
import { RefreshBlockContext } from './RefreshBlockContext';

export function useRefreshBlock() {
  const value = useContext(RefreshBlockContext);
  if (value === undefined) {
    throw Error('RefreshBlockContext is used without Provider');
  }
  return value;
}
